import { ActorObject } from './actorobject';
import { GORef } from './goref';
import { NpcSkillCmd } from './commands/npcskill';

export class MobObject extends ActorObject {
    charIdx: any;
    eventIdx: any;
    stats: any;
    hp: number;
    maxHp: number;
    level: number | undefined;
    name: string;
    ingStatus: any;

    constructor(world: any) {
        super('mob', world);
      this.charIdx = undefined;
      this.eventIdx = undefined;
      this.stats = undefined;
      this.hp = 0;
      this.maxHp = 0;
      this.level = undefined;
      this.name = '';
      this.ingStatus = undefined;
    }

    setChar(charIdx: any, callback?: () => void) {
      this.charIdx = charIdx;
      const npcTable = GDM.getNow('list_npc');
      const npcRow = npcTable.row(charIdx);
      this.pawn.setScale(npcRow[4]);
      this.pawn.setModel(charIdx, () => {
        // Create the plate only after both the model and name are ready.
        GDM.get('npc_names', (stringTable: any) => {
          const strKey = npcRow[40];
          const data = stringTable.getByKey(strKey);
          this.name = data.text;
          this.emit('name_changed');
          this.pawn.createNamePlate();
          if (callback) {
            callback();
          }
        });
      });
    }

    _skillMotion(motionIdx: number, target?: GORef) {
      if (target && target.object) {
        const deltaX = target.object.position.x - this.position.x;
        const deltaY = target.object.position.y - this.position.y;
        this.setDirection(Math.atan2(deltaY, deltaX) + Math.PI / 2);
      }

      return this._setNextCmd(new NpcSkillCmd(this, motionIdx));
    }

}

/**
 * @constructor
 */
